export default __webpack_public_path__ + "static/media/tth-cal-logo.80c935e6.png";